import { z } from "zod/v4";

import { StripeSubscriptionLinkDtoSchema } from "../../../dtos/stripe-subscription-links";

export const GetSubscriptionLinksByAgencyIdPathParamsSchema = z.object({
  agencyId: z.uuid(),
});

export type GetSubscriptionLinksByAgencyIdPathParamsType = z.infer<
  typeof GetSubscriptionLinksByAgencyIdPathParamsSchema
>;

export const GetSubscriptionLinksByAgencyIdResponseBodySchema = z.object({
  stripeSubscriptionLinks: StripeSubscriptionLinkDtoSchema.array(),
});

export type GetSubscriptionLinksByAgencyIdResponseBodyType = z.infer<
  typeof GetSubscriptionLinksByAgencyIdResponseBodySchema
>;
